module.exports = __webpack_public_path__ + "img/banner-3-4@2x.4ad64c43.jpg";